export default {
  name: 'usage',
  url: '/:orgId/usage',
  label: 'Usage',
  componentName: 'cf-platform-usage'
};



// WEBPACK FOOTER //
// ./src/javascripts/app/OrganizationSettings/Usage/UsageState.es6.js